// assets
import { IconBriefcase } from "@tabler/icons";
import { RoleLevel } from "../../../../../../../domain/entities/Role";
// constant
const icons = {
  IconBriefcase,
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const signatory = {
  id: "signatory",
  title: "My Documents",
  caption: "Sign and review my documents",
  type: "group",
  level: RoleLevel.Signatory,
  children: [
    {
      id: "myDocuments",
      title: "Document List",
      type: "item",
      url: "/mydocuments",
      icon: icons.IconBriefcase,
      color: "#009688",
      breadcrumbs: false,
    },
  ],
};

export default signatory;
